import { create } from 'zustand';
import { BoosterCode } from '../lib/network';

interface IMyTeamStore {
  activeManageBooster: BoosterCode | null;
  setActiveManageBooster: (booster: BoosterCode) => void;

  visibleActiveBoosterBanner: BoosterCode | null;
  setVisibleActiveBoosterBanner: (booster: BoosterCode) => void;

  isBoosterPendingConfirmation: boolean;
  setIsBoosterPendingConfirmation: (value: boolean) => void;
}

export const useMyTeamStore = create<IMyTeamStore>(set => ({
  activeManageBooster: null,
  setActiveManageBooster: activeManageBooster => set({ activeManageBooster }),

  visibleActiveBoosterBanner: null,
  setVisibleActiveBoosterBanner: visibleActiveBoosterBanner => set({ visibleActiveBoosterBanner }),

  isBoosterPendingConfirmation: false,
  setIsBoosterPendingConfirmation: isBoosterPendingConfirmation =>
    set({ isBoosterPendingConfirmation }),
}));
